module.exports = __webpack_public_path__ + "static/media/opacity.59aa5236.svg";